export default __webpack_public_path__ + "static/media/api-tokens.5dc80c8e.svg";